import type { JSX } from 'react';
import { VerificationTable } from './VerificationTable';
import { VerificationCard } from './VerificationCard';
import type { SortState } from '@/shared/types/table-filters.types';
import type { Verification } from '../types/verification.types';

export interface VerificationRowsProps {
  verifications: Verification[];
  sort: SortState | null;
  onToggleSort: (key: string) => void;
  onDelete: (id: string) => void;
  onCopyRefereeLink: (verificationId: string, shareId: string) => void;
}

/** Desktop table and mobile cards render the same already filtered/sorted verifications. */
export function VerificationRows({
  verifications,
  sort,
  onToggleSort,
  onDelete,
  onCopyRefereeLink,
}: VerificationRowsProps): JSX.Element {
  if (verifications.length === 0) {
    return (
      <p className="text-center py-4 text-muted-foreground">No verifications match the filters.</p>
    );
  }

  return (
    <>
      <div className="hidden md:block">
        <VerificationTable
          verifications={verifications}
          sort={sort}
          onToggleSort={onToggleSort}
          onDelete={onDelete}
          onCopyRefereeLink={onCopyRefereeLink}
        />
      </div>
      <div className="grid gap-3 md:hidden">
        {verifications.map((v) => (
          <VerificationCard
            key={v.id}
            verification={v}
            onDelete={() => onDelete(v.id)}
            onCopyRefereeLink={() => onCopyRefereeLink(v.id, v.shareId)}
          />
        ))}
      </div>
    </>
  );
}
